window.addEventListener('load', () => {
    const gButton = document.querySelectorAll('.gform_button');

    gButton.forEach(button => {
        button.classList.add('btn');
        button.classList.add('btn-yellow');
    })
})